import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/magicsquare/app/error.tsx");
